import { render, staticRenderFns } from "./QuotationTrendChart.vue?vue&type=template&id=58c962b8"
import script from "./QuotationTrendChart.vue?vue&type=script&lang=js"
export * from "./QuotationTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports